export const MARKETING_SITE_ORIGIN = `https://mixpanel.com`;

/**
 * Marketing pages are only served on mixpanel.com; regional app hosts (eu.mixpanel.com,
 * in.mixpanel.com) 404 on them, so links to marketing pages must always be absolute.
 * `path` may include a query string and hash.
 */
export function getMarketingUrl(path: string): string {
  return `${MARKETING_SITE_ORIGIN}${path.startsWith(`/`) ? `` : `/`}${path}`;
}
